import { useParams, Navigate, useLocation } from "react-router-dom";

import { Box } from "@mui/material";

import BasicTabs from "../../../../components/BasicTabs";

import { useTranslation } from "react-i18next";

import urls from "../../../../urls";

function OfficialHolidaysTabs({ fromTenant = false }) {
  const { ohName, ohID, tName, tID } = useParams();

  const { tenant_official_holidays_form, my_official_holidays_form } = urls;

  const { t } = useTranslation();

  const location = useLocation();

  if (
    !ohName ||
    !ohID ||
    ohName === "undefined" ||
    ohName === "null" ||
    ohName === "" ||
    ohID === "null" ||
    ohID === "undefined" ||
    ohID === ""
  )
    return <Navigate to={"/"} state={{ from: location }} replace />;

  const encodedName = encodeURIComponent(ohName);
  const encodedID = encodeURIComponent(ohID);

  const TabLinks = [
    {
      key: 1,
      Header: t("officialHolidays.form"),
      Link: fromTenant
        ? tenant_official_holidays_form
            .replace(
              "/:tName/:tID",
              `/${encodeURIComponent(tName)}/${encodeURIComponent(tID)}`
            )
            .replace("/:ohName/:ohID", `/${encodedName}/${encodedID}`)
        : my_official_holidays_form.replace(
            "/:ohName/:ohID",
            `/${encodedName}/${encodedID}`
          ),
    },
  ];

  return (
    <Box>
      <BasicTabs TabHeaders={TabLinks} />
    </Box>
  );
}

export default OfficialHolidaysTabs;
